// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

// <WelcomeSnippet>
import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react'
import { useAppContext } from './AppContext'
import { Button, Container, Grid, TextField, Typography } from '@mui/material'
import React from 'react'
// @ts-ignore
import { setSelectedOneDriveFile } from '../../../redux/actions'
import { connect, useSelector } from 'react-redux'
import store from '../../../redux/store'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

function mapDispatchToProps(dispatch: any) {
    return {
        setSelectedOneDriveFile: (x: any) => dispatch(setSelectedOneDriveFile(x)),
    }
}

function ConnectedWelcome(props: any) {
    const { setSelectedOneDriveFile } = props
    const app = useAppContext()
    const [searchText, setSearchText] = React.useState('')
    const selectedFile = useSelector((state) => state['selectedSharepointFile'])

    return (
        <div className="bg-light rounded-3">
            <Container>
                <AuthenticatedTemplate>
                    <div>
                        <div>
                            <Grid container wrap={'nowrap'}>
                                <Grid item>
                                    <TextField
                                        id="search-files"
                                        label="Search OneDrive"
                                        style={{ marginBottom: '20px' }}
                                        placeholder={''}
                                        value={searchText}
                                        onChange={(e) => setSearchText(e.target.value)}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item>
                                    <Button
                                        variant="contained"
                                        style={{ marginLeft: '20px' }}
                                        onClick={() => {
                                            // @ts-ignore
                                            app.searchFiles(searchText)
                                        }}
                                    >
                                        Search
                                    </Button>
                                </Grid>
                            </Grid>
                            <Accordion>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel-content"
                                    id="panel-header"
                                >
                                    <Typography>Recent Files </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    {app.recentFiles?.map((row) => {
                                        return (
                                            <Grid
                                                container
                                                wrap={'nowrap'}
                                                style={{
                                                    marginBottom: '20px',
                                                }}
                                            >
                                                <a href="javascript:void(0)">
                                                    <Grid
                                                        item
                                                        style={{
                                                            marginRight: '10px',
                                                        }}
                                                        onClick={() => {
                                                            setSelectedOneDriveFile(row)
                                                        }}
                                                    >
                                                        💾
                                                    </Grid>
                                                </a>
                                                <Grid item>{row.name}</Grid>
                                            </Grid>
                                        )
                                    })}
                                </AccordionDetails>
                            </Accordion>

                            {app.searchedFiles && app.searchedFiles.length && <h4>OneDrive Files</h4>}
                            <p>
                                Selected File:{' '}
                                {selectedFile && selectedFile.name ? selectedFile && selectedFile.name : 'None'}
                            </p>
                            {app.searchedFiles?.map((row) => {
                                return (
                                    <Grid
                                        container
                                        wrap={'nowrap'}
                                        style={{
                                            marginBottom: '20px',
                                        }}
                                    >
                                        <a href="javascript:void(0)">
                                            <Grid
                                                item
                                                style={{
                                                    marginRight: '10px',
                                                }}
                                                onClick={() => {
                                                    setSelectedOneDriveFile(row)
                                                }}
                                            >
                                                💾
                                            </Grid>
                                        </a>
                                        <Grid item>{row.name}</Grid>
                                    </Grid>
                                )
                            })}
                        </div>
                    </div>
                </AuthenticatedTemplate>
                <UnauthenticatedTemplate>
                    <Button color="primary" onClick={app.signIn!}>
                        Click here to sign in
                    </Button>
                </UnauthenticatedTemplate>
            </Container>
        </div>
    )
}

const Welcome = connect(null, mapDispatchToProps)(ConnectedWelcome)
export default Welcome
// </WelcomeSnippet>
